import {AxiosPromise, AxiosResponse} from 'axios';

export class HttpExecutor {

  private static getRequestId(): number {
    return new Date().getTime();
  }

  private funMap: HttpExecutorMap = {};

  private timeoutMap: HttpExecutorMap = {};

  executeHttp<T>(fun: (...args: any[]) => AxiosPromise<T>, ...funArgs: any[]): Promise<HttpExecutorResult<T>> {
    const funName = fun.name;
    const requestId = HttpExecutor.getRequestId();
    this.funMap[funName] = requestId;
    return new Promise((resolve, reject) => {
      fun(...funArgs)
        .then((r) => {
          let ignoreResult = false;
          if (this.funMap.hasOwnProperty(funName)) {
            ignoreResult = this.funMap[funName] !== requestId;
          } else {
            ignoreResult = true;
          }
          resolve({
            ignore: ignoreResult,
            response: r,
          })
        })
        .catch((e) => {
          reject(e)
        });
    })
  }

  executeDelayedHttp<T>(delay: number, fun: (...args: any[]) => AxiosPromise<T>, ...funArgs: any[]): Promise<HttpExecutorResult<T>> {
    const funName = fun.name;
    if (this.timeoutMap.hasOwnProperty(funName)) {
      const oldTimeout = this.timeoutMap[funName];
      clearTimeout(oldTimeout);
    }
    return new Promise<HttpExecutorResult<T>>(((resolve, reject) => {
      const timeout = setTimeout(() => {
        this.executeHttp(fun, ...funArgs)
          .then((r) => {
            if (this.timeoutMap.hasOwnProperty(funName)) {
              const oldTimeout = this.timeoutMap[funName];
              if (timeout === oldTimeout) {
                delete this.timeoutMap[funName];
              }
            }
            resolve(r)
          })
          .catch((e) => {
            reject(e)
          });
      }, delay);
      this.timeoutMap[funName] = timeout;
    }))
  }
}

// tslint:disable-next-line: interface-name
export interface HttpExecutorResult<T> {
  ignore: boolean;
  response: AxiosResponse<T>;
}

// tslint:disable-next-line: interface-over-type-literal
type HttpExecutorMap = {
  [x: string]: number;
}
